<template>
    <div class="">
        <div class=" block w-full py-2 leading-tight mb-2 flex items-center border-b border-gray-500"   v-for="(value, index) in values" :key="`${option.id}.${value.id}`" >

            
            <Incrementor :disabled="limit" v-model="selection[index]" :min="0"></Incrementor>
            
<!--            <div class="font-bold text-lg mr-2">-->
<!--            <div class="inline-block w-6 h-6 shadow rounded-full bg-white text-center mr-1 cursor-pointer" :class="selection[index]===0?'text-gray-500':''" @click="dec(index)"> - </div>-->
<!--            <div class="inline-block text-center mr-1"> {{ selection[index] }} </div>-->
<!--            <div class="inline-block w-6 h-6 shadow rounded-full bg-white text-center mr-1 cursor-pointer" :class="limit?'text-gray-500':''" @click="inc(index)"> + </div>-->
<!--            </div>-->
            <div class="flex-1 flex ml-2">

                <div class="flex-1">
            {{ value.label }}

                </div>
                <div class="font-medium">
                    {{ (value.price && value.price > 0 && selection[index] > 0 && costsmoney(index)) ? `$ ${cost(index)}` : '' }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>


    import Incrementor from "../Shared/Incrementor";
    export default {
        name: "ItemSelectorQuantity",
        components: {Incrementor},
        props: ['value', 'values', 'option'],
        data() {
            let preselect = {};
            this.value.forEach(id => {
                console.log(">>", id, preselect[id]);
                preselect[id] = preselect[id] === undefined ? 1 : preselect[id] + 1;
            })

            console.log(preselect, this.value);
            return {
                selection: this.values.map(value => {
                    const id = `${this.option.id}.${value.id}`;
                    if (preselect[id]) {
                        return preselect[id];
                    } else {
                        return 0;
                    }
                }),
            };
        },
        
        watch: {
            selection: {
                deep: true,
                handler() {
                    this.update();
                }
            }
        },

        computed: {
            total() {
                return this.selection.reduce((a, b) => a + b, 0);
            },
            limit() {
                return 1 * this.option.limit > 0 && this.option.hardlimit && this.total === 1 * this.option.limit;
            }
        },

        methods: {

            dec(index) {
                const val = this.selection[index] === 0 ? 0 : this.selection[index] - 1;
                this.selection.splice(index, 1, val);
                this.update();
            },

            inc(index) {
                if (this.limit) {
                    return;
                }
                this.selection.splice(index, 1, this.selection[index] + 1);
                this.update();
            },
            costsmoney(index) {
                if (this.option.hardlimit) {
                    return true;
                }
                const total_up_to_index = this.selection.map((value, idx) => idx <= index ? value : 0).reduce((a, b) => a + b, 0);
                return total_up_to_index > 1 * this.option.limit;

            },

            cost(index) {
                const value = this.values[index];
                if (this.option.hardlimit) {
                    return (value.price * this.selection[index]).toFixed(2);
                }

                const total_up_to_index = this.selection.map((value, idx) => idx <= index ? value : 0).reduce((a, b) => a + b, 0) - (1 * this.option.limit);

                if (total_up_to_index > this.selection[index]) {
                    return (value.price * this.selection[index]).toFixed(2);
                }

                return (value.price * total_up_to_index).toFixed(2);

            },

            update() {


                this.$emit('input', this.values.flatMap((value, index) => {
                        let out = [];
                        for (let i=0; i < this.selection[index]; i++) {
                            out.push(`${this.option.id}.${value.id}`);
                        }
                        return out;
                }).filter(id => id !== null));
            }
        }

    }
</script>

<style scoped>

</style>
